//
// 新規登録導線 step説明画面
//

document.addEventListener("DOMContentLoaded", () => {
  const uriSchemeElements = document.querySelectorAll('[data-uri-scheme]')
  if (uriSchemeElements.length == 0) return

  window.location = uriSchemeElements[0].dataset.uriScheme
})
